import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Badge } from '../../design-system';
import { formatDateTime } from '../../utils/formatters.js';
import styles from './DescriptionCell.module.css';

// "Edited by Jane Doe on 10/2/2026 3:04 PM. Scanned text: ACNE HARDWRE"
export const describeDescriptionEdit = ({ descriptionOriginal, descriptionEditedBy, descriptionEditedAt }) => {
  const who = descriptionEditedBy ? ` by ${descriptionEditedBy}` : '';
  const when = descriptionEditedAt ? ` on ${formatDateTime(descriptionEditedAt)}` : '';
  return `Edited${who}${when}. Scanned text: ${descriptionOriginal || '(blank)'}`;
};

// Transaction description with a user-correction affordance: an "Edited" marker
// (hover/focus shows the scanned text + who/when) and, for contributors, a pencil.
const DescriptionCell = ({ item, canEdit, onEdit, children }) => (
  <span className={styles.cell}>
    <span className={styles.text} title={item.description}>{item.description}</span>
    {item.descriptionEdited && (
      <Tooltip title={describeDescriptionEdit(item)} arrow>
        <span className={styles.marker} tabIndex={0} aria-label={describeDescriptionEdit(item)}>
          <Badge variant="info">Edited</Badge>
        </span>
      </Tooltip>
    )}
    {canEdit && (
      <IconButton
        size="small"
        aria-label="Edit description"
        onClick={onEdit}
        className={styles.editButton}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    )}
    {children}
  </span>
);

export default DescriptionCell;
